import { useParams } from 'react-router-dom';

import { Badge, Box, Button, Icons, Stack, Tooltip } from '@cast/design-system';

import { isDevToolboxEnabled, useToolboxState } from 'core/dev-toolbox';

import { ClusterLevelSidebar } from './ClusterLevelSidebar';
import { OrgLevelSidebar } from './OrgLevelSidebar';
import {
  sidebarContainerSx,
  sidebarNavContentSx,
  sidebarNavSx,
  sidebarToolboxSx,
} from './sidebarStyles';

import { useAbility } from '@cast/shared-ability-data-access';

import { useDboUrlParams } from 'features/db-optimization/v2/hooks/useDboParams';

import { DboSidebar } from './DboSidebar/DboSidebar';

const DevToolboxButton = () => {
  const { toggle } = useToolboxState();
  const isAnyToolActive = useToolboxState((it) => it.getIsAnyToolActive());

  return (
    <Tooltip title="Dev toolbox" placement="top">
      <Button
        size="lg"
        variant="ghost"
        onClick={toggle}
        data-testid="sidebar-item-dev-toolbox"
        sx={{ minWidth: 0, px: 8 }}
      >
        <Badge
          displayIf={isAnyToolActive}
          count={0}
          horizontal="right"
          size="dot"
          variant="primary"
          vertical="top"
        >
          <Icons.Wrench size={20} weight="light" />
        </Badge>
      </Button>
    </Tooltip>
  );
};

const SidebarInner = () => {
  const { clusterId } = useParams<{ clusterId?: string }>();
  const isDboV2Enabled = useAbility().can('view', 'FeatureDboV2');
  const { dbServerId } = useDboUrlParams();

  if (isDboV2Enabled && dbServerId) {
    return <DboSidebar />;
  }
  if (clusterId) {
    return <ClusterLevelSidebar />;
  }
  return <OrgLevelSidebar />;
};

export const Sidebar = () => {
  return (
    <Box
      component="aside"
      id="main-sidebar"
      data-testid="app-layout-sidebar"
      sx={sidebarContainerSx}
    >
      <Box component="nav" sx={sidebarNavSx}>
        <Box sx={sidebarNavContentSx}>
          <SidebarInner />
        </Box>
      </Box>

      {isDevToolboxEnabled() ? (
        <Stack sx={sidebarToolboxSx}>
          <DevToolboxButton />
        </Stack>
      ) : null}
    </Box>
  );
};
